import { ArrowRightIcon } from '@shared/assets/icons';
import clsx from 'clsx';
import { CSSProperties, FC } from 'react';
import type { ChannelMetric } from '../../lib/channel-metrics';
import styles from './metric-card.module.scss';

const formatCount = (count: number): string => count.toLocaleString('ru-RU');

const getMetricFillToneClass = (hasErrors: boolean, variant: ChannelMetric['variant']) => {
  if (hasErrors) {
    return styles.metricFillError;
  }

  if (variant === 'brand') {
    return styles.metricFillBrand;
  }

  return styles.metricFillDefault;
};

interface MetricCardProps {
  metric: ChannelMetric;
  onViewUnsent?: () => void;
}

export const MetricCard: FC<MetricCardProps> = ({ metric, onViewUnsent }) => {
  const { label, count, percent, width, variant, hasErrors } = metric;
  const isPartial = percent < 100;

  const fillClassName = clsx(
    styles.metricFill,
    getMetricFillToneClass(hasErrors, variant),
    isPartial ? styles.metricFillPartial : styles.metricFillFull
  );
  const fillStyle = isPartial ? ({ '--metric-fill-width': width } as CSSProperties) : undefined;

  return (
    <div className={styles.metricRow}>
      <div className={fillClassName} style={fillStyle}>
        <div className={styles.metricMain}>
          <span className={styles.metricCount}>{formatCount(count)}</span>
          <span className={styles.metricLabel}>{label}</span>
          {hasErrors && (
            <button type="button" className={styles.viewUnsentAction} onClick={onViewUnsent}>
              <span className={styles.viewUnsentActionText}>Посмотреть неотправленные</span>
              <ArrowRightIcon />
            </button>
          )}
        </div>
        <span className={styles.metricPercent}>{percent}%</span>
      </div>
      {isPartial && <div className={styles.metricRemainder} />}
    </div>
  );
};
